import React, { FunctionComponent, ReactNode } from "react";
import GridRow from "../../../../../components/GridRow";
import { SigmaDetection } from "../../../@types/rldynamicanalysis";

type GridRowField = {
  name: string;
  displayTitle: string;
  component: (item: SigmaDetection) => ReactNode;
  isArrayField: boolean;
};

type RlCloudSandboxSigmaDetectionsGridRowProps = {
  fields: GridRowField[];
  rowItem: SigmaDetection;
  rowIndex: string;
};

const isArrayField = (field: GridRowField) => field.isArrayField;

const RlCloudSandboxSigmaDetectionsGridRow: FunctionComponent<
  RlCloudSandboxSigmaDetectionsGridRowProps
> = props => {
  const { fields, rowItem, rowIndex } = props;

  const { description, sources } = rowItem || {};

  const [firstRow, ...otherRows] = sources || [];

  const rowSpan = sources?.length || 1;

  const arrayFields = fields?.filter(isArrayField);

  const fieldsWithRowspan = fields?.map(field => {
    if (!isArrayField(field)) {
      return { ...field, rowSpan };
    } else {
      return field;
    }
  });

  return (
    <>
      <GridRow
        {...props}
        fields={fieldsWithRowspan}
        rowItem={{ description, ...firstRow }}
      />

      {otherRows?.map((item, index) => (
        <GridRow
          {...props}
          fields={arrayFields}
          rowItem={item}
          key={`${index}-${rowIndex}`}
        />
      ))}
    </>
  );
};

export default RlCloudSandboxSigmaDetectionsGridRow;
